import {
  Editor,
  Transforms
} from 'slate';

import elementTypes from '../../elements/types';
import HelptapEditor from '../';
import * as baseNodeUtilities from './base-node';

export function getDefaultOptions() {

  const options = {
    ...baseNodeUtilities.getDefaultOptions(),
    options: {
      productId: null
    },
    children: [{
      text: ''
    }]
  };

  return options;

}

function select(editor, path) {

  Transforms.select(editor, path);

}

function doInsert(editor, options, path) {

  const node = {
    ...getDefaultOptions(),
    ...options,
    type: elementTypes.PRODUCT
  };

  HelptapEditor.insertNode(editor, node, path);

  select(editor, path);

}

export function insert(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Editor.withoutNormalizing(editor, () => {

    doInsert(editor, options, nextNodePath);

  });

}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Editor.withoutNormalizing(editor, () => {

    doInsert(editor, options, targetNodePath);
    Transforms.removeNodes(editor, { at: nextNodePath });

  });

}

export function cloneNode(node) {

  const clonedNode = HelptapEditor.cloneNode(node);

  return clonedNode;

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}